module.exports = __webpack_public_path__ + "img/animate1-11.51a33c19.png";